<div class="modal-dialog custom-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{ title | translate}}</h5>
            <button class="close" data-dismiss="modal" aria-label="Close" [mat-dialog-close]="true">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <p *ngIf="warningMessage" class="bg-warning text-primary" style="padding: 0.5rem;">{{ warningMessage | translate}}</p>
            <p *ngIf="question" class="">{{ question | translate}}</p>
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" data-dismiss="modal" (click)="onNoClick()">{{ 'back' | translate }}</button>
            <button class="btn" [class]="confirmCssStyle" data-dismiss="modal" (click)="onSubmitClick()">{{ confirm | translate }}</button>
        </div>
    </div>
</div>